import BaseService from './BaseService'

import { useLocationStore } from '@/stores/location'

class DashboardService extends BaseService {
  constructor() {
    super('/dashboard')
  }

  async getTodayStats() {
    const { getCurrentLocation } = useLocationStore()
    return this.customRequest('get', '/today', { location_id: getCurrentLocation?.id })
  }

  async getPulse() {
    const { getCurrentLocation } = useLocationStore()
    return this.customRequest('get', '/pulse', { location_id: getCurrentLocation?.id })
  }

  async getRecentSales(limit = 10) {
    return this.customRequest('get', '/recent-sales', { limit })
  }

  async getLowStockItems(threshold = 10) {
    const { getCurrentLocation } = useLocationStore()
    return this.customRequest('get', '/low-stock', { threshold, location_id: getCurrentLocation?.id })
  }
}

export const dashboardService = new DashboardService()
